import Vue from 'vue'

const ConfirmConstructor = Vue.extend(require('./index.vue').default)

let confirmInstance = null

const getInstance = () => {
  if (!confirmInstance) {
    confirmInstance = new ConfirmConstructor({ el: document.createElement('div') })
  }
  return confirmInstance
}

const Message = (function () {
  return {
    show (options, config) {
      return new Promise((resolve) => {
        const message = typeof options === 'object' ? options.message : options
        if (!confirmInstance) {
          getInstance()
          document.body.appendChild(confirmInstance.$el)
        }
        confirmInstance.message = message || ''
        confirmInstance.config = config || {}
        confirmInstance.callback = resolve
        confirmInstance.visible = true
      })
    },

    hide () {
      if (confirmInstance) confirmInstance.visible = false
    }
  }
}())

export default Message
